import { interval } from 'rxjs';
import { startWith } from 'rxjs/operators';

import Horn from '@utils/horn';
import { getStorage, setStorage } from '@utils/localStorage';
import request from '@utils/axiosWrapper';
import { reportCustomError } from '@utils/owlReporter';
import { isSwimlane } from '@utils/getEnv';

const POLLING_INTERVAL = 30 * 60 * 1000;

const FE_VERSION_CHECK_CACHE_KEY = 'feVersionCheckCache';

let currentCommitHash = '';

if (window.STATIC_ASSET_VERSION) {
    currentCommitHash = window.STATIC_ASSET_VERSION.split('-')[2];
}

/** 判断是否需要刷新页面 */
const checkIfNeedReload = (targetVersion: string) => {
    // 功能关闭，跳过检查
    if (!Horn.getConfigByFieldName(Horn.CONFIG_FIELD.FE_VERSION_CHECK_ENABLED)) {
        return;
    }
    // 泳道环境，跳转检查
    if (isSwimlane) {
        return;
    }

    /**
     * 版本号格式为：202112101340-test01-a6fc52-stable
     * 每一部分含义：发布日期时间-发布环境-发布commit-灰度状态
     */

    let targetCommitHash = '';
    targetCommitHash = targetVersion.split('-')[2];

    if (currentCommitHash && targetCommitHash && currentCommitHash !== targetCommitHash) {
        const cacheStr = getStorage(FE_VERSION_CHECK_CACHE_KEY) || '{}';
        let cacheInfo: { commitHash?: string; tryCount?: number; historyVersion?: string[] } = {};
        try {
            cacheInfo = JSON.parse(cacheStr);
        } catch (e) {
            // do nothing
        }
        if (cacheInfo.commitHash !== targetCommitHash) {
            // 全新commitHash，重置计数
            cacheInfo = {
                commitHash: targetCommitHash,
                tryCount: 1,
                historyVersion: [window.STATIC_ASSET_VERSION],
            };
        } else {
            // 已经尝试加载过的commitHash，再次加载
            cacheInfo.tryCount = (Number(cacheInfo.tryCount) || 0) + 1;

            if (!Array.isArray(cacheInfo.historyVersion)) {
                cacheInfo.historyVersion = [];
            }

            cacheInfo.historyVersion.push(window.STATIC_ASSET_VERSION);

            if (cacheInfo.tryCount > 3) {
                // 同一个版本超过3次无法稳定，则放弃刷新，防止无限刷新，上报自定义错误
                reportCustomError({
                    name: '静态资源版本刷新失败',
                    message: `加载失败的CommitHash: ${targetCommitHash}，完整版本号：${targetVersion}${
                        Array.isArray(cacheInfo.historyVersion)
                            ? ` ，历史版本号：${cacheInfo.historyVersion.join(',')}`
                            : ''
                    }`,
                    level: 'WARN',
                });
                return;
            }
        }

        setStorage(FE_VERSION_CHECK_CACHE_KEY, JSON.stringify(cacheInfo));

        // 有新发布，刷新页面
        // 网关静态资源组内多个资源生效时间可能存在秒级延迟，为避免无效刷新，增加10s延迟
        console.log('检测到新版本页面，10s后刷新页面');
        setTimeout(() => {
            window.location.reload();
        }, 10 * 1000);
    }
};

/** 轮询获取前端版本号 */
const init = () => {
    interval(POLLING_INTERVAL)
        .pipe(startWith(null))
        .subscribe(() => {
            /**
             * 1. 请求失败 => 忽略
             * 2. iframe内层加载后向外层postMessage最新版本号
             * 3. 同一版本连续3次刷新页面无法稳定 => 忽略
             */
            request.get<string>('/new_fe/feVersion_gw').then(checkIfNeedReload);
        });
};

export default { init, checkIfNeedReload };
